import React from 'react'
import { Course } from '../'
import { Card, Col, Row } from 'antd'
import { SearchOutlined } from '@ant-design/icons'

export default ({
  data,
  onRemove,
  onEdit,
  user,
  onClone,
  onTranslate,
  search,
  isLoading
}) => {
  return (
    <Row gutter={[16, 16]}>
      {data.map((item, index) => (
        <Col xs={24} sm={24} md={24} lg={12} key={index + 'course'}>
          <Course
            user={user}
            data={item}
            onRemove={onRemove}
            onEdit={onEdit}
            onClone={onClone}
            onTranslate={onTranslate}
          />
        </Col>
      ))}

      {!isLoading && data.length === 0 && (
        <Col xs={24}>
          <Card
            style={{
              textAlign: 'center',
              padding: '30px',
              borderRadius: '10px',
              background: '#f9f9f9',
              border: '1px solid #ddd'
            }}
          >
            <SearchOutlined style={{ fontSize: '32px', color: '#888' }} />
            <p style={{ marginTop: '15px', fontSize: '18px', color: '#555' }}>
              {search
                ? `No results found for "${search}"`
                : 'No items available'}
            </p>
          </Card>
        </Col>
      )}
    </Row>
  )
}
